import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var DragAndDropIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75094 6.42973C2.64673 5.60789 3.2285 4.85717 4.05035 4.75297L12.2592 3.71216C13.081 3.60796 13.8318 4.18973 13.936 5.01158L14.5815 10.1026C14.6416 10.5771 14.4731 11.0279 14.1618 11.3443L8.7996 6.13636C8.51587 5.8608 8.04019 6.05902 8.0361 6.45451L7.97408 12.4524L5.0732 12.8202C4.25135 12.9244 3.50064 12.3426 3.39644 11.5208L2.75094 6.42973Z M12.99 14.8963L11.9684 12.6058L13.2848 12.0421L8.98711 7.74447V13.8842L10.6295 13.1801L11.5412 15.4181C11.6437 15.6683 11.9432 15.7941 12.2093 15.6982L12.6918 15.5246C12.9587 15.4281 13.0924 15.1472 12.99 14.8963Z"
  }));
});
DragAndDropIcon.displayName = 'DragAndDropIcon';
export default DragAndDropIcon;